import { useSelector } from "react-redux"

function CalculatedStaffPercent(){
    const HoursStaffKashierArray = useSelector(state => state.StaffSlice.HoursStaffKashierArray)
    const HoursStaffCookArray = useSelector(state => state.StaffSlice.HoursStaffCookArray)
    const HoursStaffCookSecondGroupArray = useSelector(state => state.StaffSlice.HoursStaffCookSecondGroupArray)
    const StaffSelectedCityArray = useSelector(state => state.StaffSlice.StaffSelectedCityArray)

    const Period = useSelector(state => state.PeriodSlice.Period)

    const RevenueArray = useSelector(state => state.RevenueSlice.RevenueArray)
    const PercentCity = useSelector(state => state.RevenueSlice.PercentCity)
    return(
        <div>
            <div
            className="StaffPercentMainDiv Margin"
            >

                {Period.MinDay < 14 &&
                <div
                className="DivFlex"
                >
                    <div
                    className="RevenueCityLongDiv ColoredGray"
                    >
                        {"Просчет %"}
                    </div>

                    <div
                    className="StaffPostDiv ColoredGray"
                    >
                        Касса
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                        Сумма руб.
                    </div>
                    
                    <div
                    className="RevenueTotalDiv NoneBorder"
                    >
                    </div>
                </div>
                }
                
                {Period.MaxDay > 15 &&
                <div
                className="DivFlex"
                >
                    <div
                    className="RevenueCityLongDiv ColoredGray"
                    >
                        {"Просчет %"}
                    </div>

                    <div
                    className="StaffPostDiv ColoredGray Second"
                    >
                        Касса
                    </div>
                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                    </div>
                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                        Сумма руб.
                    </div>
                </div>
                }
                
            </div>
            {StaffSelectedCityArray.length > 0 && StaffSelectedCityArray.map((el) => 
            el.Post === "Кассир" && el.Hidden !== true && 
                <div
                className="StaffPercentMainDiv"
                >
                    {Period.MinDay < 14 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                        {el.FIO}
                    </div>
                    }
                    {el.Hours.map((a, index) => 
                    index < 15 &&
                        a.id > Period.MinDay && a.id < Period.MaxDay &&
                        <div
                        key={index}
                        className="DateDivRevenue"
                        >
                            {HoursStaffKashierArray[index] > 0 && PercentCity.Kashier > 0 ? parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[index].Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[index]) * a.Value).toFixed(2).replace('.', ',') : 0}
                        </div>
                    )}
                        
                        {Period.MinDay < 14 &&
                        <div
                        className="DivFlex"
                        >
                            <div
                            className="RevenueTotalDiv"
                            >
                            </div>

                            <div
                            className="RevenueTotalDiv"
                            >
                                 {el.Hours.reduce((Sum, item) => 
                                    item.id > Period.MinDay && item.id < Period.MaxDay && item.id < 15 && HoursStaffKashierArray[item.id] > 0 && PercentCity.Kashier > 0 
                                    ? 
                                    Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[item.id]) * item.Value) 
                                    : 
                                    Sum + 0, 0).toFixed(2).replace('.', ',') + ' руб.'}
                            </div>

                            <div
                            className="RevenueTotalDiv NoneBorder"
                            >
                            </div>
                        </div>
                        }
                    
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                        {el.FIO}
                    </div>
                    }
                    {el.Hours.map((a, index) => 
                    index > 14 &&
                        a.id > Period.MinDay && a.id < Period.MaxDay &&
                        <div
                        key={index}
                        className="DateDivRevenue"
                        >
                            {HoursStaffKashierArray[index] > 0 && PercentCity.Kashier > 0 
                            ? 
                            parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[index].Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[index]) * a.Value).toFixed(2).replace('.', ',') 
                            : 
                            0
                            }
                        </div>
                    )}

                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueTotalDiv"
                    >
                    </div>
                    }

                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueTotalDiv"
                    >
                        {el.Hours.reduce((Sum, item) => 
                            item.id > Period.MinDay && item.id < Period.MaxDay && item.id > 14 && HoursStaffKashierArray[item.id] > 0 && PercentCity.Kashier > 0 
                            ? 
                            Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.Kashier))) / HoursStaffKashierArray[item.id]) * item.Value) 
                            : 
                            Sum + 0, 0
                            ).toFixed(2).replace('.', ',') + ' руб.'}
                    </div>
                    }
                    
                    
                </div>
            )}

            <div
            className="StaffPercentMainDiv"
            >

                {Period.MinDay < 14 &&
                <div
                className="DivFlex"
                >
                    <div
                    className="RevenueCityLongDiv ColoredGray"
                    >
                        {"Просчет %"}
                    </div>

                    <div
                    className="StaffPostDiv ColoredGray"
                    >
                        Повара (группа 1)
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                        Сумма руб.
                    </div>
                    
                    <div
                    className="RevenueTotalDiv NoneBorder"
                    >
                    </div>
                </div>
                }
                
                {Period.MaxDay > 15 &&
                <div
                className="DivFlex"
                >
                    <div
                    className="RevenueCityLongDiv ColoredGray"
                    >
                        {"Просчет %"}
                    </div>

                    <div
                    className="StaffPostDiv ColoredGray Second">
                        Повара (группа 1)
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                    </div>
                

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                        Сумма руб.
                    </div>
                </div>
                }
                
            </div>
            {StaffSelectedCityArray.length > 0 && StaffSelectedCityArray.map((el) => 
            (el.Post === "Повар" || el.Post === "Повар 1 группа") && el.Hidden !== true &&
                <div
                className="StaffPercentMainDiv"
                >
                    {Period.MinDay < 14 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                        {el.FIO}
                    </div>
                    }

                    {el.Hours.map((a, index) => 
                    index < 15 &&
                    a.id > Period.MinDay && a.id < Period.MaxDay &&
                        <div
                        key={index}
                        className="DateDivRevenue"
                        >
                            {HoursStaffCookArray[index] > 0 && PercentCity.Cook > 0 ? parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[index].Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[index]) * a.Value).toFixed(2).replace('.', ',') : 0}
                        </div>
                    )}

                        {Period.MinDay < 14 &&
                        <div
                        className="DivFlex"
                        >
                            <div
                            className="RevenueTotalDiv"
                            >
                            </div>

                            <div
                            className="RevenueTotalDiv"
                            >
                                {el.Hours.reduce((Sum, item) => item.id > Period.MinDay && item.id < Period.MaxDay && item.id < 15 && HoursStaffCookArray[item.id] > 0 && PercentCity.Cook > 0 ? Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[item.id]) * item.Value) : Sum + 0, 0).toFixed(2).replace('.', ',') + ' руб.'}
                            </div>
                            
                            <div
                            className="RevenueTotalDiv NoneBorder"
                            >
                            </div>
                        </div>
                        }
                    
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                        {el.FIO}
                    </div>
                    }

                    {el.Hours.map((a, index) => 
                    index > 14 &&
                    a.id > Period.MinDay && a.id < Period.MaxDay &&
                        <div
                        key={index}
                        className="DateDivRevenue"
                        >
                            {HoursStaffCookArray[index] > 0 && PercentCity.Cook > 0 ? parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[index].Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[index]) * a.Value).toFixed(2).replace('.', ',') : 0}
                        </div>
                    )}

                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueTotalDiv"
                    >
                    </div>
                    }


                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueTotalDiv"
                    >
                        {el.Hours.reduce((Sum, item) => item.id > Period.MinDay && item.id < Period.MaxDay &&  item.id > 14 && HoursStaffCookArray[item.id] > 0 && PercentCity.Cook > 0 ? Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.Cook))) / HoursStaffCookArray[item.id]) * item.Value) : Sum + 0, 0).toFixed(2).replace('.', ',') + ' руб.'}
                    </div>
                    }
                    
                </div>
            )}

            <div
            className="StaffPercentMainDiv"
            >

                {Period.MinDay < 14 &&
                <div
                className="DivFlex"
                >
                    <div
                    className="RevenueCityLongDiv ColoredGray"
                    >
                        {"Просчет %"}
                    </div>

                    <div
                    className="StaffPostDiv ColoredGray"
                    >
                        Повара (группа 2)
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                        Сумма руб.
                    </div>
                    
                    <div
                    className="RevenueTotalDiv NoneBorder"
                    >
                    </div>
                </div>
                }
                
                {Period.MaxDay > 15 &&
                <div
                className="DivFlex"
                >
                    <div
                    className="RevenueCityLongDiv ColoredGray"
                    >
                        {"Просчет %"}
                    </div>

                    <div
                    className="StaffPostDiv ColoredGray Second">
                        Повара (группа 2)
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                    </div>
                

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                        Сумма руб.
                    </div>
                </div>
                }
                
            </div>
            {StaffSelectedCityArray.length > 0 && StaffSelectedCityArray.map((el) => 
            el.Post === "Повар 2 группа" && el.Hidden !== true &&
                <div
                className="StaffPercentMainDiv"
                >
                    {Period.MinDay < 14 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                        {el.FIO}
                    </div>
                    }

                    {el.Hours.map((a, index) => 
                    index < 15 &&
                    a.id > Period.MinDay && a.id < Period.MaxDay &&
                        <div
                        key={index}
                        className="DateDivRevenue"
                        >
                            {HoursStaffCookSecondGroupArray[index] > 0 && PercentCity.CookSecondGroup > 0 ? parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[index].Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[index]) * a.Value).toFixed(2).replace('.', ',') : 0}
                        </div>
                    )}

                        {Period.MinDay < 14 &&
                        <div
                        className="DivFlex"
                        >
                            <div
                            className="RevenueTotalDiv"
                            >
                            </div>

                            <div
                            className="RevenueTotalDiv"
                            >
                                {el.Hours.reduce((Sum, item) => item.id > Period.MinDay && item.id < Period.MaxDay && item.id < 15 && HoursStaffCookSecondGroupArray[item.id] > 0 && PercentCity.CookSecondGroup > 0 ? Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[item.id]) * item.Value) : Sum + 0, 0).toFixed(2).replace('.', ',') + ' руб.'}
                            </div>
                            
                            <div
                            className="RevenueTotalDiv NoneBorder"
                            >
                            </div>
                        </div>
                        }
                    
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                        {el.FIO}
                    </div>
                    }

                    {el.Hours.map((a, index) => 
                    index > 14 &&
                    a.id > Period.MinDay && a.id < Period.MaxDay &&
                        <div
                        key={index}
                        className="DateDivRevenue"
                        >
                            {HoursStaffCookSecondGroupArray[index] > 0 && PercentCity.CookSecondGroup > 0 ? parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[index].Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[index]) * a.Value).toFixed(2).replace('.', ',') : 0}
                        </div>
                    )}

                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueTotalDiv"
                    >
                    </div>
                    }


                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueTotalDiv"
                    >
                        {el.Hours.reduce((Sum, item) => item.id > Period.MinDay && item.id < Period.MaxDay &&  item.id > 14 && HoursStaffCookSecondGroupArray[item.id] > 0 && PercentCity.CookSecondGroup > 0 ? Sum + parseFloat(parseFloat(parseFloat(parseFloat(RevenueArray[item.id].Value) / 100 * (parseFloat(PercentCity.CookSecondGroup))) / HoursStaffCookSecondGroupArray[item.id]) * item.Value) : Sum + 0, 0).toFixed(2).replace('.', ',') + ' руб.'}
                    </div>
                    }
                    
                </div>
            )}            
            
        </div>
    )
}

export default CalculatedStaffPercent